<template>
  <b-col xl="2" lg="3" md="6" sm="6" xs="12" class="item">
    <b-img thumbnail :src="item_product.thumbnail" :alt="item_product.name"/>
    <h5 class="mt-2">{{ item_product.name }}</h5>
    <span> {{ productName(item) }} <br></span>
    <span><b>تعداد:</b> {{ item.quantity }}</span>

  </b-col>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter"
import {productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: 'BasketItemColumn',
  props: ['item', 'item_product'],
  data() {
    return {}
  },
  methods: {
    formatNumber,
    productName
  },
}
</script>

<style scoped>
.item {
  text-align: center;
}

img {
  width: 150px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  float: none;
}

h5 {
  text-align: center;
  font-size: 12pt;
  font-weight: 400;
}
</style>
